// extracted by mini-css-extract-plugin
module.exports = {"table-wrapper":"table-wrapper___2r2Mc","table":"table___2Bd6R"};